import React from 'react';
import './ToggleSwitch.css'; // See CSS below

const ToggleSwitch = ({ options = [], value, onChange, disabledOptions = [] }) => {
  return (
    <div className="toggle-switch">
      {options.map((option) => {
        const isDisabled = disabledOptions.includes(option);
        return (
          <button
            key={option}
            className={`toggle-button 
              ${value === option ? 'active' : ''} 
              ${isDisabled ? 'disabled' : ''}`}
            onClick={() => !isDisabled && onChange(option)}
            disabled={isDisabled}
          >
            {option}
          </button>
        );
      })}
    </div>
  );
};


export default ToggleSwitch;
